export const adminRoles = Object.freeze({
    superAdmin: "superAdmin",
    moderator: "moderator"
});
